import { useEffect, useState } from "react";
import { useAuth } from "../../components/Auth/context";
import { AuthStatus } from "../../components/Auth/service";

export const useAuthenticatedQueryOptions = () => {
  const auth = useAuth();
  const [authStatus, setAuthStatus] = useState<AuthStatus>(AuthStatus.NONE);

  useEffect(() => {
    const subscription = auth.getStatus().subscribe((status) => {
      setAuthStatus(status);
    });
    return () => subscription.unsubscribe();
  }, [auth]);

  const hasToken = auth.hasToken();
  const skip = authStatus !== AuthStatus.SIGNED_IN || !hasToken;

  return { skip, authStatus, hasToken };
};
